export const DEFAULT_COORDINATES = {
  x: 0,
  y: 0,
} as const
